module.exports = __webpack_public_path__ + "media/about/residential-a204dba4.jpg";